import React from 'react'

function Tag({
  children,
  color,
  className,
}: {
  children: string
  color: string
  className?: string
}) {
  return (
    <span
      className={`rounded-lg h-8 mt-1 uppercase text-xs ${color} py-1 px-2 inline ${className}`}
    >
      {children}
    </span>
  )
}

export default Tag
